import { TM2 } from '@models/core';

export const TM2Config: TM2['config'] = window['_TM2'] && window['_TM2']['config'];
